import axios from 'axios';

const setAuthToken = (token) => {
	if (token) {
		axios.defaults.headers.common['x-auth-newish-token'] = token;
	} else {
		delete axios.defaults.headers.common['x-auth-newish-token'];
	}
};

export default setAuthToken;
